import type { JiraPlanDataRestResponse } from '@atlassian/jira-software-backlog-uif-types/src/index.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import { JiraViewAri } from '@atlassian/ari/jira';
// eslint-disable-next-line jira/import-whitelist
import parameters from '@atlassian/jira-spa-apps-next-gen-backlog/src/ui/backlog/api-consumer/view-settings-data-resolver/__generated__/viewSettingsDataResolverQuery$parameters';
import type { viewSettingsDataResolverQuery } from '@atlassian/jira-spa-apps-next-gen-backlog/src/ui/backlog/api-consumer/view-settings-data-resolver/__generated__/viewSettingsDataResolverQuery.graphql';

import { RESOURCE_TYPE_NEXTGEN_BACKLOG_REST_RESOURCE } from './constants.tsx';

export const uifBacklogResource: RouteResource<JiraPlanDataRestResponse | null> =
	createResource<JiraPlanDataRestResponse | null>({
		type: RESOURCE_TYPE_NEXTGEN_BACKLOG_REST_RESOURCE,
		getKey: ({
			match: {
				params: { boardId },
			},
			query: { config },
		}) =>
			/*
            When navigating to and from the board settings page we need
            the data to get reloaded. So we are updating the key to force a refresh
        */
			['uif-backlog-data']
				.concat(boardId ?? '')
				.concat(config ? `config-${config}` : '')
				.filter(Boolean)
				.join('-'),
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-nextgen-plandata-rest", jiraSpaEntry: "async-nextgen-plandata-rest" */ './get-data'
			),
		// Setting mexAge to 0 so it will get the data again after coming back from a config page
		maxAge: 0,
	});

const getQuery: Parameters<
	typeof createRelayResource<viewSettingsDataResolverQuery>
>[0]['getQuery'] = ({ match }, { tenantContext: { activationId, cloudId } }) => {
	const viewId = JiraViewAri.create({
		activationId,
		siteId: cloudId,
		scopeId: `${match.params.boardId}/backlog`,
		scopeType: 'board',
	}).toString();

	return {
		options: {
			fetchPolicy: 'store-and-network' as const,
		},
		parameters,
		variables: {
			input: {
				jiraBacklogViewQueryInput: {
					viewId,
				},
			},
		},
	};
};

export const backlogCMPViewSettingsResource = createRelayResource<viewSettingsDataResolverQuery>({
	type: 'BACKLOG_CMP_VIEW_SETTINGS_RESOURCE',
	getQuery,
});
